import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "grid grid-cols-2 md:grid-cols-3 gap-3" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"w-20 h-20 rounded-full mx-auto bg-gray-100 dark:bg-gray-900 animate-pulse\"></div><div class=\"mt-4 rounded p-1 bg-gray-900 animate-pulse mx-5\"></div><div class=\"grid grid-cols-4 gap-2 mx-5\"><div class=\"mt-4 rounded p-1 bg-gray-900 animate-pulse col-span-3\"></div><div class=\"mt-4 rounded p-1 bg-gray-900 animate-pulse\"></div></div>", 3)
const _hoisted_6 = {
  key: 1,
  class: "grid grid-cols-2 md:grid-cols-3 gap-3"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "appFont" }
const _hoisted_9 = { class: "text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_LinkButton = _resolveComponent("LinkButton")!

  return (!_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
            return _createElementVNode("div", {
              key: i,
              class: _normalizeClass(["dark:bg-gray-800 px-2 py-3 rounded-lg", {'hidden md:block': i == 2}])
            }, [
              _hoisted_3,
              _createVNode(_component_Button, { class: "w-full mt-5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Spinner)
                ]),
                _: 1
              })
            ], 2)
          }), 64))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
          return (_openBlock(), _createElementBlock("div", {
            key: user.id,
            class: "dark:bg-gray-800 px-2 py-3 rounded-lg"
          }, [
            _createElementVNode("img", {
              class: _normalizeClass(["w-20 h-20 rounded-full mx-auto", {'!rounded-md': _ctx.premiumCubeImage(user)}]),
              src: _ctx.$profileImage(user.profile_image_path),
              alt: "Profile Image"
            }, null, 10, _hoisted_7),
            _createElementVNode("p", _hoisted_8, _toDisplayString(user.username), 1),
            _createElementVNode("small", _hoisted_9, _toDisplayString(user.display_name), 1),
            _createVNode(_component_LinkButton, {
              class: "w-full",
              to: '/user/' + user.username
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, { class: "w-full mt-5" }, {
                  default: _withCtx(() => [
                    _createTextVNode("View")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ]))
}